import axios from "axios";

// Deleting a purchase whose bill has a payment against it, or a sale whose
// invoice has money received, is asked about, not refused: the server answers
// 409 with details.code = "bill_has_payments" (purchase) or
// "invoice_has_receipts" (sale), and the dialog offers "Delete anyway", which
// resends with ?confirm_paid=true. Returns the server's sentence (it names the
// amount) when that is the error, null for anything else so the caller shows
// its plain error.
const fallbacks: Record<string, string> = {
  bill_has_payments: "This purchase's bill has payments. Deleting it also deletes them.",
  invoice_has_receipts: "Money has been paid on this sale. Deleting it keeps that money as the buyer's credit.",
};

export function extractPaidBillWarning(err: unknown): string | null {
  if (!axios.isAxiosError(err) || err.response?.status !== 409) return null;
  const data = err.response.data as { error?: string; details?: { code?: string } } | undefined;
  const code = data?.details?.code;
  if (!code || !(code in fallbacks)) return null;
  return data?.error ?? fallbacks[code];
}
